import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemVibranceOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-vibrance-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemVibranceOption(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemVibrance = useGetKeyFromEffectsActiveItem('vibrance');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || activeItemVibrance === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateVibrance = (vibrance: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          vibrance,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemVibranceOption vibrance={activeItemVibrance} updateVibrance={updateVibrance} />;
}
